






























import { defineComponent } from '@nuxtjs/composition-api'
import InputError from '@/components/Inputs/new-design/InputError.vue'

export default defineComponent({
  name: 'InputCheckbox',
  components: { InputError },
  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: [String, Boolean],
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
    hasBorder: {
      type: Boolean,
      default: true,
    },
  },
  setup(_, context) {
    const onCheckToggle = (event: InputEvent) => {
      const checked = (event.target as HTMLInputElement)?.checked
      context.emit('input', checked)
    }

    return {
      onCheckToggle,
    }
  },
})
